<template>
	<div>
		<!-- <div class="col-m-2"> -->
			<div>
				<b-form-datepicker id="datepicker" size="sm" :date-disabled-fn="dateDisabled" @context="onDatePicked" v-model="date1" class="mb-1" today-button close-button locale="zh"></b-form-datepicker>
			</div>
			<div v-if="stocks.length">
				<div v-bind:key="data.index" v-for="(data) in stocks">
					<b-list-group>
						<div class="mb-1">
							<StockTextPopularItem @p_show_kline="p_show_kline"
							:rank="data.rank"  :rank_diff="data.rank_diff" :stock_name="data.symbol_name" :stock_code="data.symbol_code" :pct="data.last_pct"></StockTextPopularItem>
							<!-- {{data}} -->
						</div>
					</b-list-group>
				</div>
			</div>
			<div v-else>
				<h5>无数据，换一天试试 😢</h5>
			</div>
		<!-- </div> -->
		<!-- <div class="col-9"></div> -->
	</div>
</template>

<script>
	import {
		request_zzquant
	} from "network/request.js"

	import StockTextPopularItem from 'components/stock/StockTextPopularItem.vue'

	export default {
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + this.mendZero((now.getMonth()) + 1) + '-' + this.mendZero(now.getDate());
			return {
				date1: today,
				stocks: []
			};
		},
		components: {
			StockTextPopularItem,
			// Navbar
		},
		mounted() {
			this.refresh_popular();
		},
		methods: {
			mendZero(num) {
				return (num = num < 10 ? '0' + num : num)
			},
			onDatePicked(){
				// console.log(ctx.selectedYMD);
				this.refresh_popular();
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()
				
				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if(weekday === 0 || weekday === 6){
					return true;
				}
				//今天之后不能选
				if(time>=now_time){
					return true;
				}
				return false
			},
			refresh_popular(){
				request_zzquant({
						// url: 'stock/d/popular/' + this.date1
						url:'/open/sentiment/media/ths2/top?date1='+this.date1+'&top_n=100'
					})
					.then(res1 => {
						// console.log(res1['data']['data']);
						this.stocks = res1['data']['data'];
					})
					.catch(err => {
						console.log(err);
					});
			},
			p_show_kline(symbol_code){
				// console.log("p click "+symbol_code);
				this.$emit('p_show_kline',symbol_code)
			}
		}
	};
</script>

<style>
	
</style>
